import PropTypes from 'prop-types'
import { useCallback, useState } from 'react'

import { MENSAJE_TIPO_PREGUNTA } from '../../../constants/mensajesTipos.js'
import { ESTADO_PUBLICADA, SIN_PREGUNTAS_TEXTO } from '../../../constants/publicaciones'
import { esMensajeDeMiEmpresa } from '../../../helpers/esMensajeDeMiEmpresa'
import { toastErrorLog } from '../../../helpers/toastErrorLog'
import { insertarMail } from '../../servicios/mailsServices'
import { insertar } from '../../servicios/mensajesService'
import Input from '../../ui/Input'
import { adjuntoBuilder } from '../upload/adjuntoBuilder'
import { ModalUpload } from '../upload/ModalUpload'
import { Mensaje } from './Mensaje'
import styles from './MensajeriaNew.module.css'

const MAX_PREGUNTAS_VISIBLES = 3

export const MensajeriaNew = ({
  id,
  tipoDoc,
  titulo,
  idVendedor,
  mensajes,
  tipoMensajes,
  usuario,
  actualizarMensajes,
  idComprador,
  idMensajeTipo,
  idPublicacionEstado,
  pedidoEntregado,
  empid,
  empidVendedor = ''
}) => {
  const [texto, setTexto] = useState('')
  const [showModal, setShowModal] = useState(false)
  const [visualizacionPreguntas, setVisualizacionPreguntas] = useState(false)
  const [adjuntosPendientes, setAdjuntosPendientes] = useState([])

  const handleToggle = () => setShowModal((prev) => !prev)

  const handleSubmit = (e) => {
    e.preventDefault()
    if (texto.trim() !== '' || adjuntosPendientes.length > 0) {
      submit()
    }
  }

  const esEmisorLadoVendedor = () => {
    if (usuario === idVendedor) return true
    if (usuario === idComprador) return false

    if (empid) {
      const mensajeConEmpid = mensajes.find((m) => m.empidVendedor || m.empidComprador)

      if (mensajeConEmpid) {
        if (empid === mensajeConEmpid.empidVendedor) return true
        if (empid === mensajeConEmpid.empidComprador) return false
      }
    }

    return usuario === idVendedor
  }

  const submit = async () => {
    try {
      const emisorLadoVendedor = esEmisorLadoVendedor()

      const mensaje = {
        idMensajePadre: null,
        idUsuarioChat: emisorLadoVendedor ? idComprador : idVendedor,
        idUsuarioEmisor: usuario,
        idComprador,
        idVendedor,
        texto: texto.trim(),
        privado: tipoDoc === 'pedido' || tipoDoc === 'pedidoCabecera',
        IdsAdjuntosList:
          adjuntosPendientes.length > 0 ? adjuntosPendientes.map((a) => a.idAdjunto) : null,
        ...(tipoDoc === 'publicacion'
          ? { idPublicacion: id }
          : tipoDoc === 'pedido'
            ? { idPedidoItem: id }
            : tipoDoc === 'presupuesto'
              ? { idPresupuesto: id }
              : tipoDoc === 'pedidoCabecera'
                ? { idPedido: id }
                : {}),
        idMensajeTipo: tipoDoc === 'publicacion' ? MENSAJE_TIPO_PREGUNTA : idMensajeTipo || -1
      }

      const mail = {
        idTo: (emisorLadoVendedor ? idComprador : idVendedor).toString(),
        idTipo: 1,
        param2:
          tipoDoc === 'publicacion'
            ? 'en la publicación'
            : tipoDoc === 'pedido'
              ? 'en el pedido'
              : tipoDoc === 'presupuesto'
                ? 'en el presupuesto'
                : '',
        param3: id !== null ? id.toString() : ''
      }

      await insertar(mensaje)
      await insertarMail(mail)
      await actualizarMensajes()
      setTexto('')
      setAdjuntosPendientes([])
    } catch (error) {
      const mensaje = `Ocurrió un error al enviar mensaje.`
      toastErrorLog(error, mensaje, 'mensajeria')
    }
  }

  const manejarAdjunto = useCallback(async (data, setAdjunto, id) => {
    const { dataAdjunto, adjunto } = data

    const previewAdjunto = await adjuntoBuilder(dataAdjunto, adjunto, adjunto.archivo, {
      preview: true
    })

    setAdjunto((prev) => {
      if (prev.some((x) => x.idAdjunto === (adjunto.idAdjunto || id))) {
        return prev
      }
      return [...prev, { ...previewAdjunto, idAdjunto: adjunto.idAdjunto || data.idAdjunto || id }]
    })
  }, [])

  const getFileIcon = (filename) => {
    if (filename.endsWith('.pdf')) {
      return 'fa-file-pdf-o'
    }
    if (filename.endsWith('.doc') || filename.endsWith('.docx')) {
      return 'fa-file-word-o'
    }
    if (filename.endsWith('.xls') || filename.endsWith('.xlsx')) {
      return 'fa-file-excel-o'
    }
    return 'fa-file-o'
  }

  const esMensajePropio = (m) => esMensajeDeMiEmpresa(m, usuario, empid)
  const mensajesPropios = tipoMensajes === 'preguntas' ? mensajes.filter(esMensajePropio) : mensajes
  const mensajesOtros =
    tipoMensajes === 'preguntas' ? mensajes.filter((m) => !esMensajePropio(m)) : []
  const tienePropios = mensajesPropios.length > 0
  const mensajesVisibles = tienePropios ? mensajesPropios : mensajesOtros
  const mostrarBotonVerMas = tienePropios
    ? mensajesOtros.length > 0
    : mensajesOtros.length > MAX_PREGUNTAS_VISIBLES

  return (
    <div className={styles.contenedorMensajes}>
      <div className="contenedor-msj">
        <h3 className={styles.titulo}>
          {tipoMensajes === 'preguntas'
            ? !tienePropios || idVendedor === usuario
              ? titulo
              : 'Tus preguntas'
            : titulo}
        </h3>
        <div className={tipoMensajes === 'preguntas' ? styles.listaMensajes : undefined}>
          {(tipoMensajes === 'preguntas' ? mensajesVisibles : mensajes)
            .slice(0, tipoMensajes === 'preguntas' ? MAX_PREGUNTAS_VISIBLES : undefined)
            .map((mensaje) => (
              <Mensaje
                key={mensaje.idMensaje}
                mensaje={mensaje}
                usuario={usuario}
                empid={empid}
                tipoMensajes={tipoMensajes}
              />
            ))}
          {mensajes.length === 0 && tipoMensajes === 'preguntas' && (
            <p className={styles.sinRespuesta}>{SIN_PREGUNTAS_TEXTO}</p>
          )}
        </div>
        {mostrarBotonVerMas && (
          <div className="text-center">
            <button
              className={`btn btn-success ${styles.botonVisualizarPreguntas}`}
              onClick={() => setVisualizacionPreguntas(true)}
            >
              Ver preguntas de otros usuarios
            </button>
          </div>
        )}
        {visualizacionPreguntas && (
          <div
            className={`modal fade show d-block ${styles.divVisualizacionPreguntasBlack}`}
            tabIndex="-1"
            role="dialog"
          >
            <div className="modal-dialog modal-lg" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Preguntas de otros usuarios</h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => setVisualizacionPreguntas(false)}
                  ></button>
                </div>
                <div
                  className={`modal-body ${styles.divMensajesVisualizacion} ${styles.listaMensajes} ${styles.modalMensajesBody}`}
                >
                  {(tienePropios ? mensajesOtros : mensajesOtros.slice(MAX_PREGUNTAS_VISIBLES)).map(
                    (mensaje) => (
                      <Mensaje
                        key={mensaje.idMensaje}
                        mensaje={mensaje}
                        usuario={usuario}
                        empid={empid}
                        tipoMensajes={tipoMensajes}
                      />
                    )
                  )}
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={() => setVisualizacionPreguntas(false)}
                  >
                    Cerrar
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
        {(tipoDoc !== 'publicacion' || (idVendedor && usuario !== idVendedor)) && (
          <form onSubmit={handleSubmit} className={styles.chatForm}>
            {adjuntosPendientes.length > 0 && (
              <div className={styles.adjuntosContainer}>
                {adjuntosPendientes.map((adjunto, index) => (
                  <div key={index} className={styles.previewAdjunto}>
                    {adjunto.contentType?.startsWith('image/') ? (
                      <img src={adjunto.url} alt="preview" className={styles.previewImagen} />
                    ) : (
                      <a
                        href={adjunto.url}
                        target="_blank"
                        rel="noreferrer"
                        className={styles.archivoNombre}
                        title={adjunto.nombre}
                      >
                        <i className={`fa ${getFileIcon(adjunto.nombre)}`} />
                        <span className={styles.archivoTexto}>{adjunto.nombre}</span>
                      </a>
                    )}
                    <button
                      type="button"
                      className={styles.removeAdjunto}
                      onClick={() =>
                        setAdjuntosPendientes((prev) => prev.filter((_, i) => i !== index))
                      }
                    >
                      x
                    </button>
                  </div>
                ))}
              </div>
            )}

            {!pedidoEntregado &&
            (idPublicacionEstado === undefined || idPublicacionEstado === ESTADO_PUBLICADA) &&
            empidVendedor !== empid ? (
              <div className={styles.inputArea}>
                <span className={styles.attachButton}>
                  <i
                    aria-hidden="true"
                    className="fa fa-paperclip"
                    onClick={() => setShowModal(true)}
                  />
                </span>

                <Input
                  type="text"
                  name="texto"
                  value={texto}
                  onChange={(e) => setTexto(e.target.value)}
                  className={styles.input}
                  placeholder="Escribí tu pregunta"
                />

                <button
                  className={styles.sendButton}
                  type="submit"
                  disabled={!texto.trim() && adjuntosPendientes.length === 0}
                >
                  <i className="fa fa-paper-plane" />
                </button>
              </div>
            ) : null}
          </form>
        )}
      </div>
      <ModalUpload
        show={showModal}
        onClose={handleToggle}
        idTipo={10}
        idDoc={id}
        idPerfil={usuario}
        adjuntoPendiente={adjuntosPendientes}
        onCarga={(data) => manejarAdjunto(data.data, setAdjuntosPendientes)}
      />
    </div>
  )
}

MensajeriaNew.propTypes = {
  id: PropTypes.number.isRequired,
  tipoDoc: PropTypes.string.isRequired,
  titulo: PropTypes.string,
  idVendedor: PropTypes.number.isRequired,
  idComprador: PropTypes.number.isRequired,
  mensajes: PropTypes.arrayOf(PropTypes.object).isRequired,
  tipoMensajes: PropTypes.string,
  usuario: PropTypes.number.isRequired,
  actualizarMensajes: PropTypes.func.isRequired,
  idMensajeTipo: PropTypes.number,
  idPublicacionEstado: PropTypes.number,
  pedidoEntregado: PropTypes.bool,
  empid: PropTypes.string,
  empidVendedor: PropTypes.string
}
